import React, { useState } from 'react';
import {
  AddressSearch,
  AddressSearchProps,
  PlacesSearchProps,
} from 'components';
import AddElement from './AddElement';
import Label from './Label';

interface AddCompanyAddressProps {
  onSelectOption: PlacesSearchProps['onSelect'];
  onInputChange: AddressSearchProps['onInputChange'];
}

const AddCompanyAddress: React.FC<AddCompanyAddressProps> = ({
  onInputChange,
  onSelectOption,
}) => {
  const [active, setActive] = useState(false);

  const onSelect: typeof onSelectOption = prediction => {
    setActive(false);
    onSelectOption(prediction);
  };

  return active ? (
    <>
      <Label label="Company Address" />
      <AddressSearch
        type="places"
        placesType="establishment"
        onSelect={onSelect}
        onInputChange={onInputChange}
      />
    </>
  ) : (
    <AddElement label="Address" onClick={() => setActive(true)} />
  );
};

export default AddCompanyAddress;
